#import "../../../core-entity/graphql/fragments/widget-fragment-full.graphql"
#import "../../../core-entity/graphql/fragments/header-field-fragment.graphql"

mutation UpdatePeepWidgets($input: WidgetEntityTypeUpdateInput!) {
    widgetEntityTypeUpdate(input: $input) {
        sidebar {
            ...WidgetFragmentFull
        }
        workspace {
            ...WidgetFragmentFull
        }
        headerFields {
            ...HeaderFieldFragment
        }
    }
}
